var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.66666C6 9.97466 8.692 12.6667 12 12.6667C15.308 12.6667 18 9.97466 18 6.66666C18 3.35866 15.308 0.666656 12 0.666656C8.692 0.666656 6 3.35866 6 6.66666ZM22.6667 26H24V24.6667C24 19.5213 19.812 15.3333 14.6667 15.3333H9.33333C4.18667 15.3333 0 19.5213 0 24.6667V26H1.33333H2.66667H21.3333H22.6667Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYou);
export default __webpack_public_path__ + "static/media/you.a9915d2632e40218afe57a61101607fa.svg";
export { ForwardRef as ReactComponent };